export default __webpack_public_path__ + "static/voltadol.schmerzen.schulter.01-5b4e1a7d3b1e757a570ebe1ecd8a1bf0.jpg";